var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 328 328",
    style: {
      enableBackground: "new 0 0 328 328"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,0C73.4,0,0,73.4,0,164s73.4,164,164,164c90.6,0,164-73.4,164-164S254.6,0,164,0z M192.3,167 c-1.6,19.1-7.4,37.4-10.2,56.3c-0.4,3.6-1.3,9.4,0.5,11.2c4.9,5.1,10,12.6,7.5,21.7c-2.3,8.4-10.9,15.1-19.7,15.1 c-14.3,0-25-13.5-27.8-25.4c-2-8.5-1.9-17-0.7-25.5c2.3-17.1,7-33.8,9.6-50.8c-7.7-1.2-14.6-7.1-16.7-14.8 c-3-11,3.6-21.6,14.2-24.9c11.2-3.5,26.4-3.1,34.7,6.8C193.8,148.7,192.7,161.9,192.3,167z M166,112.8c-15.5,0-28-12.6-28-28 c0-15.5,12.6-28,28-28s28,12.6,28,28S181.4,112.8,166,112.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c3ced705418f952a388602e8cde21eee.svg";
export { ForwardRef as ReactComponent };